module.exports = __webpack_public_path__ + "static/media/brands-gg.a19293dc.png";